import jQuery from 'jquery';
import getResponsiveWidth from '../functions/getResponsiveWidth';

_initLinks();

function _initLinks() {
    $("a[href$='.pdf'],a[href^='http://'],a[href^='www.'],a[href^='https://'],a[data-rel='external']")
        .not("a[href^='http://" + location.hostname + "']")
        .not("a[href^='https://" + location.hostname + "']")
        .not("[target='_self']")
        .attr('target','_blank');
}

$.fn.serializeObject = function() {
    let form = this[0];
    let formdata = new FormData(form);
    let object = {};
    for(let item of formdata) {
        object = Object.assign({[item[0]] : item[1]}, object);
    }
    return object;
}
